import { format, isValid } from 'date-fns';
import { format as dateFnsTzFormat } from 'date-fns-tz';

const hasTimezoneInfo = (value: string): boolean => (
  /[zZ]|[+-]\d{2}:?\d{2}$|\bGMT\b|\bUTC\b/.test(value)
);

const toDate = (value: string | Date): Date => {
  if (value instanceof Date) {
    return value;
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return new Date('');
  }
  const normalized = hasTimezoneInfo(trimmed) ? trimmed : `${trimmed}Z`;
  return new Date(normalized);
};

export const formatDate = (date: string | Date | undefined): string => (date === undefined ? ''
  : format(new Date(date), 'Y-MM-dd'));

export const formatDateReadable = (date: string): string => (format(new Date(date), 'MMM yyyy'));

export const formatDateUSReadable = (date: string | undefined): string => (
  date ? format(new Date(date), 'MMM dd, yyyy') : ''
);

export const formatDateTimeToLocal = (date: string | Date | undefined | null): string => {
  if (!date) {
    return '';
  }
  const parsed = toDate(date);
  if (!isValid(parsed)) {
    return '';
  }
  return dateFnsTzFormat(parsed, "MMM dd, yyyy 'at' p");
};

export const formatDateWithoutTimeZoneDifference = (date: string | undefined): string => (
  date ? new Date(date).toLocaleDateString('en-US', {
    timeZone: 'UTC', month: 'short', day: '2-digit', year: 'numeric',
  }) : ''
);
